// removed by extract-text-webpack-plugin
module.exports = {"container":"_1L0a","gray":"_2NhS","dark":"_3ESi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CaseStudy/TextSection/styles.scss
// module id = 534
// module chunks = 0